import React, { useState, useCallback, useEffect } from 'react'
import { Grid } from '@material-ui/core'
import { Grid as KendoGrid, GridColumn as KendoGridColumn, GridNoRecords } from '@progress/kendo-react-grid'
import {
  TooltipHLPure,
  TextAreaHLPure,
  PanelBarGLPure,
  ButtonAddHLPure,
  DataPickerHLPure,
  InteractiveDialog,
  DropDownBtnHLPure,
  DialogAddUserPure,
  InputSwitchHLPure,
  DialogSystemGLPure,
  GridSelectionHLPure,
  DialogShareUsersPure,
} from '../../pures'
import { UserService, LocalStorageService } from '../../../services'
import DocumentListDialog from './DocumentListDialog'
import { ArrowBtnMobile } from '../../../assets/logos/icons'
import { useMediaQuery } from '@material-ui/core'

const INFO_TYPE_DOCUMENT = Number(process.env.REACT_APP_INFO_TYPE_DOCUMENT)

const HeaderColumns = (props) => {
  return (
    <span className={(props.title === props.t('digitalVaultUploadView.grid.title.1') || props.title === props.t('digitalVaultUploadView.modal.entities.grid.title.1')) ? 'grid-header-one' : 'grid-headers'}>{props.title}</span>
  )
}


const CellColumnOne = (props) => {
  const { dataItem, t, hasDocumentList } = props
  const hasDocs = hasDocumentList ? hasDocumentList(dataItem.email) : false

  return (
    <td className={`digitalVaultUploadView-col1 ${dataItem.selected ? 'selected' : ''}`}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <div>
          <p className='grid-cell-titles-margin-left-thirdParty-title grid-cell-title' style={{ margin: '0' }}>{dataItem.name}</p>
          <p className='grid-cell-titles-margin-left-thirdParty grid-cell-subtitle' style={{ margin: '0' }}>
            {dataItem.requestType || t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.freeRequest')}
          </p>
        </div>
      </div>
    </td>
  )
}

/**
 * @function ThirdPartyDocumentPanel
 * @description Panel para solicitar documentos a terceros (colaboradores o invitados)
 * @param {{
 *   t: function,
 *   uploadData: {infoType: number, name: string, uploadedFiles: Array, description: string},
 *   documentId: number|null,
 *   fileShown: {name: string, fileBase64: string, fileType: string, type: string, file: boolean},
 *   setFileType: function,
 *   handleWathchExp: function,
 *   deleteFile: function,
 *   setFileSelected: function,
 *   collaboratorsAll: Array,
 *   invitedAll: Array,
 *   setCollaboratorsAll: function,
 *   setInvitedAll: function,
 *   permissionsCheckBox: Array
 * }} props
 * @returns {JSX.Element}
 */
const ThirdPartyDocumentPanel = (props) => {
  const {
    t,
    uploadData,
    permissionsCheckBox = [],
    selectedUsers = [],
    setSelectedUsers,
    userDocumentLists = {},
    setUserDocumentLists,
    userInstructions = {},
    setUserInstructions,
    requestDeadline,
    setRequestDeadline,
    enableSecondApproval = false,
    setEnableSecondApproval,
    secondApprovalUser = null,
    setSecondApprovalUser,
    showSendButton = false,
    userIsShared = false,
    onSendRequest,
    documentGroups = [],
    documentTemplates = [],
    onSaveDocumentList,
  } = props

  // Estados locales para usuarios
  const [collaboratorsAll, setCollaboratorsAll] = useState([])
  const [invitedAll, setInvitedAll] = useState([])

  // Estados para las opciones de solicitud
  const [applyToAllUsers, setApplyToAllUsers] = useState(false)

  // Estados para el modal de lista de documentos
  const [showDocumentListDialog, setShowDocumentListDialog] = useState(false)
  const [selectedUserForList, setSelectedUserForList] = useState(null)

  // Estados locales para el diálogo de compartir
  const [activeShareTab, setActiveShareTab] = useState(process.env.REACT_APP_USER_TAB_COLLABORATORS)
  const [collaboratorPermissions, setCollaboratorPermissions] = useState([])
  const [showLoadingRequesting, setShowLoadingRequesting] = useState(false)
  const [invitedPermissions, setInvitedPermissions] = useState([])
  const [showDialogShare, setShowDialogShare] = useState(false)
  const [messageShare, setMessageShare] = useState('')
  const [userSearch, setUserSearch] = useState('')

  // Estados para agregar colaborador
  const [newCollaborator, setNewCollaborator] = useState({ email: '', firstName: '', lastName: '' })
  const [showDialogAddCollaborator, setShowDialogAddCollaborator] = useState(false)
  const [addCollaboratorErrors, setAddCollaboratorErrors] = useState({})

  // Estados para agregar invitado
  const [newInvited, setNewInvited] = useState({ email: '', firstName: '', lastName: '' })
  const [showDialogAddInvited, setShowDialogAddInvited] = useState(false)
  const [addInvitedErrors, setAddInvitedErrors] = useState({})

  // Estados para modal de instrucciones
  const [showInstructionsModal, setShowInstructionsModal] = useState(false)
  const [instructionsText, setInstructionsText] = useState('')
  const [applyInstructionsToAll, setApplyInstructionsToAll] = useState(false)
  const [globalApplyInstructionsToAll, setGlobalApplyInstructionsToAll] = useState(false)
  const [selectedUserForInstructions, setSelectedUserForInstructions] = useState(null)

  // Estados para modal de confirmación de eliminación
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [userToDelete, setUserToDelete] = useState(null)

  // Estados para modal de confirmación de aplicar lista a todos
  const [showApplyToAllConfirm, setShowApplyToAllConfirm] = useState(false)
  const [applyToAllAction, setApplyToAllAction] = useState('activate')

  // Estado para controlar qué usuario tiene el detalle expandido
  const [expandedUserId, setExpandedUserId] = useState(null)

  // Estados para modal de advertencia
  const [showWarningModal, setShowWarningModal] = useState(false)
  const [warningMessage, setWarningMessage] = useState('')

  // Estado para usuarios validadores
  const [usersValidators, setUsersValidators] = useState([])

  // Servicios - Inicializar con la URL de la API
  const url = process.env.REACT_APP_MIFIRMA_API

  const loadValidators = useCallback(async () => {
    try {
      const userService = new UserService(url)
      const localStorageService = new LocalStorageService()
      const token = localStorageService.getLocalStorageItem('token')?.idToken
      if (!token) return

      const response = await userService.getUsersValidators(token)

      if (response && response.statusCode === 200 && response.data) {
        const mappedValidators = response.data
          .filter(v => v.user && v.user.active)
          .map(validator => {
            const user = validator.user

            const fullName = user.fullName?.trim()
            const constructedName = [user.firstName, user.firstLastName, user.secondLastName]
              .filter(Boolean)
              .join(' ')
              .trim()

            const displayName = fullName || constructedName || user.email || `Usuario ${validator.userId}`

            return {
              id: validator.userId,
              email: user.email,
              name: displayName
            }
          })

        setUsersValidators(mappedValidators)
      }
    } catch (error) {
      console.error('[loadValidators] Error:', error)
      setUsersValidators([])
    }
  }, [url])

  useEffect(() => {
    loadValidators()
  }, [loadValidators])


  useEffect(() => {
    if (uploadData.infoType === INFO_TYPE_DOCUMENT) {
      if (selectedUsers.length === 1) {
        const currentUser = selectedUsers[0]
        const previousUserEmails = Object.keys(userDocumentLists)
        const userEmailsToRemove = previousUserEmails.filter(
          email => email !== currentUser.email
        )

        if (userEmailsToRemove.length > 0) {
          const newUserDocumentLists = { ...userDocumentLists }
          userEmailsToRemove.forEach(email => {
            delete newUserDocumentLists[email]
          })
          setUserDocumentLists(newUserDocumentLists)
        }
      }
    }
  }, [selectedUsers, uploadData.infoType])

  const loadUsers = useCallback(async (isCollaborators) => {
    setShowLoadingRequesting(true)
    try {
      const userService = new UserService(url)
      const localStorageService = new LocalStorageService()
      const tokenData = localStorageService.getLocalStorageItem('token')
      const token = tokenData?.idToken

      if (!token) {
        setShowLoadingRequesting(false)
        return
      }

      const data = await userService.getUsersCollaboratorsOrInvites(
        token,
        isCollaborators,
        !isCollaborators,
        isCollaborators ? null : 0,
        isCollaborators ? null : 50,
        userSearch || ''
      )

      let page = []
      if (isCollaborators) {
        page = data?.usersCollaborator?.active || data?.active || data || []
      } else {
        page = data?.usersInvite?.active || data?.active || data || []
      }

      const actives = page.filter((u) => u?.status === true || u?.active === true || u?.enabled === true)
      const mapped = actives.map((u) => ({
        id: u.id ?? u.userId ?? null,
        name:
          u.name ||
          u.fullName ||
          [u.firstName, u.firstLastName, u.secondLastName].filter(Boolean).join(' ') ||
          (u.email ? String(u.email).split('@')[0] : '-') ||
          '-',
        email: (u.email || '').toLowerCase(),
        checked: false,
        userTypeId: isCollaborators ? Number(process.env.REACT_APP_USER_TYPE_COLABORADOR) : Number(process.env.REACT_APP_USER_TYPE_INVITADO),
        source: isCollaborators ? 'collaborator' : 'invited'
      }))

      if (isCollaborators) {
        setCollaboratorsAll(mapped)
      } else {
        setInvitedAll(mapped)
      }
    } catch (error) {
      console.error('Error loading users:', error)
    } finally {
      setShowLoadingRequesting(false)
    }
  }, [url, userSearch])

  const handleOpenCloseDialogShare = async () => {
    if (showDialogShare) {
      // Cerrar y resetear
      setMessageShare('')
      setUserSearch('')
      setActiveShareTab(process.env.REACT_APP_USER_TAB_COLLABORATORS)

      setCollaboratorsAll(prev => prev.map(u => ({ ...u, checked: false })))
      setInvitedAll(prev => prev.map(u => ({ ...u, checked: false })))

      const defaultPerms = permissionsCheckBox.map(p => ({ ...p, checked: false }))
      setCollaboratorPermissions(defaultPerms)

      setShowDialogShare(false)
    } else {
      if (uploadData.infoType === INFO_TYPE_DOCUMENT && uploadData.uploadedFiles && uploadData.uploadedFiles.length > 0) {
        setWarningMessage(t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.warning.cannotAddUsersWithFiles'))
        setShowWarningModal(true)
        return
      }
      // Mostrar loading solo si no hay usuarios cargados
      const shouldLoadCollaborators = collaboratorsAll.length === 0
      const shouldLoadInvited = invitedAll.length === 0
      const shouldLoadAny = shouldLoadCollaborators || shouldLoadInvited

      if (shouldLoadAny) {
        // Primero mostrar loading
        setShowLoadingRequesting(true)

        // Cargar colaboradores e invitados en paralelo (solo los que no estén cargados)
        await Promise.all([
          shouldLoadCollaborators ? loadUsers(true) : Promise.resolve(),
          shouldLoadInvited ? loadUsers(false) : Promise.resolve()
        ])

        // Cerrar loading
        setShowLoadingRequesting(false)
      }

      const selectedEmails = selectedUsers.map(u => u.email)
      setCollaboratorsAll(prev => prev.map(u => ({
        ...u,
        checked: selectedEmails.includes(u.email)
      })))
      setInvitedAll(prev => prev.map(u => ({
        ...u,
        checked: selectedEmails.includes(u.email)
      })))

      // Después de cargar (o si ya estaban cargados), abrir modal
      setShowDialogShare(true)
    }
  }

  const handleChangeTab = (tab) => {
    setActiveShareTab(tab)
    setUserSearch('')

    // Cargar usuarios del tab si no están cargados
    if (tab === process.env.REACT_APP_USER_TAB_COLLABORATORS && collaboratorsAll.length === 0) {
      loadUsers(true)
    } else if (tab === process.env.REACT_APP_USER_TAB_INVITED && invitedAll.length === 0) {
      loadUsers(false)
    }
  }

  const filterChangeUsers = (e) => {
    setUserSearch(e.target.value)
  }

  const handleChangeMessageShare = (e) => {
    setMessageShare(e.target.value)
  }

  const onChangeCheckShare = (e, user, isSingleUserMode = false) => {
    const isCollaboratorTab = !activeShareTab || activeShareTab === process.env.REACT_APP_USER_TAB_COLLABORATORS

    if (isCollaboratorTab) {
      setCollaboratorsAll(prev => {
        if (isSingleUserMode) {
          // En modo documento: si hace clic en el mismo usuario, toggle; sino desmarcar todos y marcar solo el seleccionado
          return prev.map(u => {
            if (u.email === user.email) {
              return { ...u, checked: !u.checked }
            } else {
              return { ...u, checked: false }
            }
          })
        } else {
          // En modo expediente: toggle normal
          return prev.map(u =>
            u.email === user.email ? { ...u, checked: !u.checked } : u
          )
        }
      })
    } else {
      setInvitedAll(prev => {
        if (isSingleUserMode) {
          // En modo documento: si hace clic en el mismo usuario, toggle; sino desmarcar todos y marcar solo el seleccionado
          return prev.map(u => {
            if (u.email === user.email) {
              return { ...u, checked: !u.checked }
            } else {
              return { ...u, checked: false }
            }
          })
        } else {
          // En modo expediente: toggle normal
          return prev.map(u =>
            u.email === user.email ? { ...u, checked: !u.checked } : u
          )
        }
      })
    }
  }

  const onTogglePermission = (e, permission) => {
    const isCollaboratorTab = !activeShareTab || activeShareTab === process.env.REACT_APP_USER_TAB_COLLABORATORS

    if (isCollaboratorTab) {
      setCollaboratorPermissions(prev =>
        prev.map(p =>
          p.nameBD === permission.nameBD ? { ...p, checked: !p.checked } : p
        )
      )
    } else {
      setInvitedPermissions(prev =>
        prev.map(p =>
          p.nameBD === permission.nameBD ? { ...p, checked: !p.checked } : p
        )
      )
    }
  }

  const handleSubmitDialogShare = () => {
    const isCollaboratorTab = !activeShareTab || activeShareTab === process.env.REACT_APP_USER_TAB_COLLABORATORS
    const sourceList = isCollaboratorTab ? collaboratorsAll : invitedAll
    const selected = sourceList.filter(u => u.checked)

    if (selected.length > 0) {
      const isSingleDocumentMode = uploadData.infoType === INFO_TYPE_DOCUMENT
      const newUsers = []

      setSelectedUsers(prev => {
        if (isSingleDocumentMode) {
          newUsers.push(selected[0])
          return [selected[0]]
        } else {
          const existingEmails = prev.map(u => u.email)
          const filtered = selected.filter(u => !existingEmails.includes(u.email))
          newUsers.push(...filtered)
          return [...prev, ...filtered]
        }
      })

      if (applyToAllUsers && hasAnyUserWithDocuments) {
        const firstList = getFirstConfiguredList()
        if (firstList.length > 0) {
          setTimeout(() => {
            setUserDocumentLists(prev => {
              const newLists = { ...prev }
              newUsers.forEach(user => {
                newLists[user.email] = firstList
              })
              return newLists
            })
          }, 0)
        }
      }
    }

    handleOpenCloseDialogShare()
  }

  const handleOpenAddCollaborator = () => {
    setShowDialogAddCollaborator(true)
  }

  const handleCloseAddCollaborator = () => {
    setShowDialogAddCollaborator(false)
    setNewCollaborator({ email: '', firstName: '', lastName: '' })
    setAddCollaboratorErrors({})
  }

  const handleAddCollaboratorChange = (event, field) => {
    const value = event?.target?.value ?? ''
    setNewCollaborator((prev) => ({ ...prev, [field]: value }))
    setAddCollaboratorErrors((prev) => ({
      ...prev,
      emailInvalid: false,
      emailExists: false,
      [field]: false
    }))
  }

  const handleAddCollaboratorSubmit = (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault()

    const email = (newCollaborator.email || '').trim().toLowerCase()
    const firstName = (newCollaborator.firstName || '').trim()
    const lastName = (newCollaborator.lastName || '').trim()

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    let hasError = false
    const nextErrors = {
      emailInvalid: false,
      emailExists: false,
      firstName: false,
      lastName: false
    }

    // Validaciones
    if (!emailRegex.test(email)) {
      nextErrors.emailInvalid = true
      hasError = true
    }
    if (firstName.length < 2) {
      nextErrors.firstName = true
      hasError = true
    }
    if (lastName.length < 2) {
      nextErrors.lastName = true
      hasError = true
    }

    // Verificar si ya existe
    const alreadyExists = collaboratorsAll.some(u =>
      (u.email || '').toLowerCase() === email
    )
    if (alreadyExists) {
      nextErrors.emailExists = true
      hasError = true
    }

    setAddCollaboratorErrors(nextErrors)
    if (hasError) return

    // Agregar nuevo colaborador a la lista
    const newUser = {
      id: null,
      name: `${firstName} ${lastName}`.trim(),
      email,
      checked: false,
      userTypeId: Number(process.env.REACT_APP_USER_TYPE_COLABORADOR)
    }

    setCollaboratorsAll((prev) => [newUser, ...prev])
    handleCloseAddCollaborator()
  }

  const handleOpenAddInvited = () => {
    setShowDialogAddInvited(true)
  }

  const handleCloseAddInvited = () => {
    setShowDialogAddInvited(false)
    setNewInvited({ email: '', firstName: '', lastName: '' })
    setAddInvitedErrors({})
  }

  const handleAddInvitedChange = (event, field) => {
    const value = event?.target?.value ?? ''
    setNewInvited((prev) => ({ ...prev, [field]: value }))
    setAddInvitedErrors((prev) => ({
      ...prev,
      emailInvalid: false,
      emailExists: false,
      [field]: false
    }))
  }

  const handleAddInvitedSubmit = (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault()

    const email = (newInvited.email || '').trim().toLowerCase()
    const firstName = (newInvited.firstName || '').trim()
    const lastName = (newInvited.lastName || '').trim()

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    let hasError = false
    const nextErrors = {
      emailInvalid: false,
      emailExists: false,
      firstName: false,
      lastName: false
    }

    // Validaciones
    if (!emailRegex.test(email)) {
      nextErrors.emailInvalid = true
      hasError = true
    }
    if (firstName.length < 2) {
      nextErrors.firstName = true
      hasError = true
    }
    if (lastName.length < 2) {
      nextErrors.lastName = true
      hasError = true
    }

    // Verificar si ya existe
    const alreadyExists = invitedAll.some(u =>
      (u.email || '').toLowerCase() === email
    )
    if (alreadyExists) {
      nextErrors.emailExists = true
      hasError = true
    }

    setAddInvitedErrors(nextErrors)
    if (hasError) return

    // Agregar nuevo invitado a la lista
    const newUser = {
      id: null,
      name: `${firstName} ${lastName}`.trim(),
      email,
      checked: false,
      userTypeId: Number(process.env.REACT_APP_USER_TYPE_INVITADO),
      source: 'invited'
    }

    setInvitedAll((prev) => [newUser, ...prev])
    handleCloseAddInvited()
  }

  // Handlers agrupados para DialogShareUsersPure y DialogAddUserPure
  const handlers = {
    handleOpenCloseDialogShare,
    handleSubmitDialogShare,
    handleChangeTab,
    filterChangeUsers,
    handleChangeMessageShare,
    onChangeCheckShare,
    onTogglePermission,
    handleOpenAddCollaborator,
    handleCloseAddCollaborator,
    handleAddCollaboratorChange,
    handleAddCollaboratorSubmit,
    handleOpenAddInvited,
    handleCloseAddInvited,
    handleAddInvitedChange,
    handleAddInvitedSubmit,
    activeShareTab
  }

  // Usuarios filtrados según la búsqueda y tab activo
  const usersGrid = (() => {
    const isCollaboratorTab = !activeShareTab || activeShareTab === process.env.REACT_APP_USER_TAB_COLLABORATORS
    const sourceList = isCollaboratorTab ? collaboratorsAll : invitedAll

    if (!userSearch || userSearch.trim() === '') {
      return sourceList
    }

    const searchLower = userSearch.toLowerCase()
    return sourceList.filter(u =>
      (u.name || '').toLowerCase().includes(searchLower) ||
      (u.email || '').toLowerCase().includes(searchLower)
    )
  })()

  const hasDocumentList = (userEmail) => {
    return userDocumentLists[userEmail] && userDocumentLists[userEmail].length > 0
  }

  const handleExpandChange = (event) => {
    const clickedUser = event.dataItem
    const hasDocs = hasDocumentList(clickedUser.email)
    if (hasDocs) {
      clickedUser.expanded = !clickedUser.expanded
      setExpandedUserId(clickedUser.expanded ? clickedUser.email : null)
    }
  }

  const AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
  const heightGrid = 'var(--panelHeight)'
  const widthColumnOne = '150px'
  const widthColumnFive = '100px'
  const mobileResolution = useMediaQuery('(max-width:560px)')
  const showOnlyArrow = useMediaQuery('(max-width:500px)')
  const showFullButtons = useMediaQuery('(min-width:920px)')

  let skip = 0
  if (selectedUsers.length > 0) {
    skip = 0
  }

  const enrichedUsers = selectedUsers.map(user => {
    const hasList = hasDocumentList(user.email)
    return {
      ...user,
      buttonLabel: hasList
        ? t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.editList')
        : t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.createList'),
      requestType: hasList
        ? t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.documentListGrid')
        : t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.freeRequest'),
      expanded: user.email === expandedUserId && hasList,
      hasDocuments: hasList
    }
  })

  const handleSaveDocumentList = (userEmail, selectedDocumentIds) => {
    if (applyToAllUsers) {
      const newLists = {}
      selectedUsers.forEach(user => {
        newLists[user.email] = [...selectedDocumentIds]
      })
      setUserDocumentLists(newLists)
    } else {
      if (selectedDocumentIds && selectedDocumentIds.length > 0) {
        setUserDocumentLists(prev => {
          const newLists = {
            ...prev,
            [userEmail]: selectedDocumentIds
          }
          return newLists
        })
      } else {
        setUserDocumentLists(prev => {
          const newLists = { ...prev }
          delete newLists[userEmail]
          return newLists
        })
      }
    }
  }

  const iconMessage = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_COMMENTS_WHITE_ICON}`

  const hasAnyUserWithDocuments = Object.keys(userDocumentLists).some(
    email => userDocumentLists[email]?.length > 0
  )

  const hasDifferentLists = () => {
    if (selectedUsers.length === 0) return false

    const usersWithList = selectedUsers.filter(user => {
      const list = userDocumentLists[user.email]
      return list && list.length > 0
    }).length

    if (usersWithList === 0) return false

    if (usersWithList < selectedUsers.length) return true

    const listsWithContent = selectedUsers.map(user => userDocumentLists[user.email])
    const firstListIds = listsWithContent[0].map(doc => doc.id).sort().join(',')

    return listsWithContent.some(list => {
      const listIds = list.map(doc => doc.id).sort().join(',')
      return listIds !== firstListIds
    })
  }

  const getFirstConfiguredList = () => {
    for (const email in userDocumentLists) {
      if (userDocumentLists[email] && userDocumentLists[email].length > 0) {
        return userDocumentLists[email]
      }
    }
    return []
  }

  const UserDocumentsDetailRow = (rowProps) => {
    const userEmail = rowProps?.dataItem?.email
    const documentObjects = userDocumentLists[userEmail] || []

    if (documentObjects.length === 0) return null

    const userDocuments = documentObjects.map((doc, index) => ({
      id: doc.id,
      documentName: doc.name,
      documentType: '',
      _index: index
    }))

    const handleRemoveDocument = (documentIndex) => {
      const updatedDocs = documentObjects.filter((doc, index) => index !== documentIndex)
      handleSaveDocumentList(userEmail, updatedDocs)
    }

    return (
      <KendoGrid
        data={userDocuments}
        width={'103%'}
        resizable
      >
        <KendoGridColumn
          width={'100%'}
          headerCell={() => null}
          cell={(p) => (
            <td style={{ padding: '12px 16px', border: 'none', backgroundColor: 'transparent' }}>
              <span style={{ fontWeight: 'bold', color: '#2C353C', fontSize: '16px', fontFamily: 'Quicksand' }}>
                {p.dataItem.documentName}
              </span>
            </td>
          )}
        />
        <KendoGridColumn
          width={'20%'}
          headerCell={() => null}
          cell={(p) => (
            <td style={{ textAlign: 'center', padding: '12px', border: 'none', backgroundColor: 'transparent' }}>
              <button
                onClick={() => handleRemoveDocument(p.dataItem._index)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#E74C3C',
                  fontSize: '18px'
                }}
                title={t('button.delete')}
              >
                <i className='k-icon k-i-delete k-i-trash' />
              </button>
            </td>
          )}
        />
        <GridNoRecords>
          <span style={{
            color: "#2C353C",
            fontSize: "14px",
            fontWeight: 550,
            fontFamily: "Quicksand"
          }}>
            {t("configurationDomainPanel.notResults")}
          </span>
        </GridNoRecords>
      </KendoGrid>
    )
  }

  return (
    <>
      <Grid>
        <PanelBarGLPure
          expandedPanel={true}
          titlePanel={`${t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.title')}`}
          id='documentPanelBarVariables'
          actionComponent={<ButtonAddHLPure
            nameBtn={mobileResolution ? '' : t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.title.add.users')}
            onClickBtn={handleOpenCloseDialogShare}
            iconAdd
            customIcon=''
          />}
        >

          {showSendButton && onSendRequest && selectedUsers.length > 0 && (
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', padding: '0 20px' }}>
              <ButtonAddHLPure
                nameBtn='Enviar solicitud'
                onClickBtn={onSendRequest}
              />
            </div>
          )}

          <div className='digitalVaultDocumentView'>
            {selectedUsers.length > 0 && (
              <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                {/* Fecha límite de la solicitud */}
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <label className='inputHLPure-label' >
                    {t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.limitDateSolicitud')}
                  </label>
                  <DataPickerHLPure
                    valueDate={requestDeadline}
                    handleChangeDate={(e) => setRequestDeadline(e.target.value)}
                    formatPicker='dd/MM/yyyy'
                    limitDate={new Date()}
                    maxDate={(() => {
                      const maxDate = new Date()
                      maxDate.setDate(maxDate.getDate() + 60)
                      return maxDate
                    })()}
                  />
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <label className="inputHLPure-label" >
                      {t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.secondApproval')}
                    </label>
                    <TooltipHLPure
                      positionTooltip={'top'}
                      titleTooltip={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.secondApproval')}
                      descriptionTooltip={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.secondApproval.tooltip.description')}
                      informationIcon
                    />
                  </div>
                  <InputSwitchHLPure
                    checked={enableSecondApproval}
                    onChange={(e) => {
                      setEnableSecondApproval(e.value)
                      if (!e.value) {
                        setSecondApprovalUser(null)
                      }
                    }}
                  />
                </div>

                {enableSecondApproval && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {usersValidators && usersValidators.length > 0 ? (
                      <DropDownBtnHLPure
                        optionsDropDown={usersValidators}
                        nameOption="name"
                        valueItem="id"
                        optionsValue={secondApprovalUser?.id || null}
                        onDropDownChange={(e) => {
                          const selectedId = e.target.value
                          const selected = usersValidators.find(u => u.id === selectedId)
                          setSecondApprovalUser(selected || null)
                        }}
                      />
                    ) : (
                      <p style={{ fontSize: '14px', color: '#666' }}>
                        {t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.noValidatorsAvailable')}
                      </p>
                    )}
                  </div>
                )}
                {uploadData.infoType !== INFO_TYPE_DOCUMENT && hasAnyUserWithDocuments && (
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <label className="inputHLPure-label" >
                        {t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.applyToAll')}
                      </label>
                      <TooltipHLPure
                        positionTooltip={'top'}
                        titleTooltip={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.applyToAll')}
                        descriptionTooltip={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.applyToAll.tooltip.description')}
                        informationIcon
                      />
                    </div>
                    <InputSwitchHLPure
                      checked={applyToAllUsers}
                      onChange={(e) => {
                        if (e.value) {
                          if (hasDifferentLists()) {
                            setApplyToAllAction('activate')
                            setShowApplyToAllConfirm(true)
                          } else {
                            setApplyToAllUsers(true)
                          }
                        } else {
                          setApplyToAllAction('deactivate')
                          setShowApplyToAllConfirm(true)
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            )}

            <Grid className='ThirdPartyDocumentRequestPanel-grid-documents'>
              <GridSelectionHLPure
                key={`grid-users-${Object.keys(userDocumentLists).length}-${expandedUserId}`}
                styleGeneral={true}
                styleGeneralClass={'documentPanelBarVariables-general-grid'}
                skip={0}
                take={enrichedUsers.length}
                pageable={false}
                dataGrid={enrichedUsers}
                noRecordsMessage={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.title.grid.no.users')}

                titleRow1={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.title.grid')}
                cellColumnOne={(props) => (
                  <CellColumnOne
                    {...props}
                    t={t}
                    hasDocumentList={hasDocumentList}
                  />
                )}
                headerColumnOne={AllHeadersColumns}
                widthColumnOne={widthColumnOne}

                columnFive
                columnFiveStyleClass={'digitalVaultUploadView-cellActions'}
                titleRow5={t('digitalVaultUploadView.grid.title.5')}
                iconOneActive={true}
                labelOneActions={(dataItem) => dataItem.buttonLabel}
                activeDialog1={true}
                btnOpenDialog1={(dataItem) => {
                  setSelectedUserForList(dataItem)
                  setShowDocumentListDialog(true)
                }}
                iconFifth={!showOnlyArrow}
                iconFifthActive={!showOnlyArrow}
                iconSrc={iconMessage}
                onFifthActionClick={(dataItem) => {
                  setSelectedUserForInstructions(dataItem)
                  setInstructionsText(userInstructions[dataItem.email] || '')
                  setApplyInstructionsToAll(globalApplyInstructionsToAll)
                  setShowInstructionsModal(true)
                }}
                iconTrashActive
                labelTrashActions={showFullButtons ? t('button.delete') : ''}
                activeDialogTrash
                btnOpenDialogTrash={(dataItem) => {
                  setUserToDelete(dataItem)
                  setShowDeleteConfirm(true)
                }}
                tooltipTrashIcon={t('button.delete')}
                mobileFunction
                widthColumnFive={showOnlyArrow ? '50px' : widthColumnFive}
                minResizableWidth5={showOnlyArrow ? '50px' : widthColumnFive}
                styleGrid={{ height: heightGrid }}
                onSelectedItem={() => { }}
                setNameComponentUser={() => { }}
                setShowDetails={() => { }}

                {...(hasAnyUserWithDocuments ? {
                  detail: (props) => {
                    const userHasDocs = props.dataItem.hasDocuments
                    return userHasDocs ? <UserDocumentsDetailRow {...props} /> : null
                  },
                  expandField: 'expanded',
                  onExpandChange: handleExpandChange
                } : {})}

              />
            </Grid>
          </div>
        </PanelBarGLPure>
      </Grid>

      {/* Modal de compartir usuarios */}
      {!showDialogAddCollaborator && !showDialogAddInvited && showDialogShare && (
        <DialogShareUsersPure
          t={t}
          documentData={uploadData}
          usersGrid={usersGrid}
          userSearch={userSearch}
          handlers={handlers}
          submitButtonLabel={t('button.save')}
          titleDialog={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.title.add.users')}
          showPermissions={false}
          showMessage={false}
          showInvitedDownloadPermission={false}
          isSingleUserMode={uploadData.infoType === INFO_TYPE_DOCUMENT}
          showDescriptionWithSelection={uploadData.infoType === INFO_TYPE_DOCUMENT}
          description={
            uploadData.infoType === INFO_TYPE_DOCUMENT ? (
              <>
                <span>{t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.description')}</span> <strong>{t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.description_strong')}</strong>
                <span>{t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.description_2')}</span> <strong>{t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.description_strong_2')}</strong>
              </>
            ) :
              ''
          }
        />
      )}

      {/* Modal de agregar colaborador */}
      {showDialogAddCollaborator && (
        <DialogAddUserPure
          showDialog={showDialogAddCollaborator}
          type='collaborator'
          t={t}
          newUser={newCollaborator}
          userErrors={addCollaboratorErrors}
          handlers={handlers}
        />
      )}

      {/* Modal de agregar invitado */}
      {showDialogAddInvited && (
        <DialogAddUserPure
          showDialog={showDialogAddInvited}
          type='invited'
          t={t}
          newUser={newInvited}
          userErrors={addInvitedErrors}
          handlers={handlers}
        />
      )}

      {/* Modal de carga */}
      <DialogSystemGLPure
        showLoadingRequesting={showLoadingRequesting}
        toggleLoadingRequesting={() => setShowLoadingRequesting(false)}
        showConfirm={showDeleteConfirm || showApplyToAllConfirm}
        confirmTitle={
          showDeleteConfirm
            ? t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.deleteUser.title')
            : showApplyToAllConfirm && applyToAllAction === 'deactivate'
              ? t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.title.removeApplyToAll')
              : t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.title.applyToAll')
        }
        confirmMessage={
          showDeleteConfirm
            ? t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.deleteUser.message')
            : showApplyToAllConfirm && applyToAllAction === 'deactivate'
              ? t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.removeApplyToAll.confirm.message')
              : t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.applyToAll.confirm.message')
        }
        handleConfirmDeleteFlowClose={() => {
          if (showDeleteConfirm) {
            setShowDeleteConfirm(false)
            setUserToDelete(null)
          } else if (showApplyToAllConfirm) {
            setShowApplyToAllConfirm(false)
          }
        }}
        handleConfirmDeleteFlowSubmit={() => {
          if (showDeleteConfirm) {
            if (userToDelete) {
              setSelectedUsers(prev => prev.filter(u => u.email !== userToDelete.email))
              setUserDocumentLists(prev => {
                const newLists = { ...prev }
                delete newLists[userToDelete.email]
                return newLists
              })
            }
            setShowDeleteConfirm(false)
            setUserToDelete(null)
          } else if (showApplyToAllConfirm) {
            if (applyToAllAction === 'activate') {
              const firstList = getFirstConfiguredList()
              if (firstList.length > 0) {
                const newLists = {}
                selectedUsers.forEach(user => {
                  newLists[user.email] = [...firstList]
                })
                setUserDocumentLists(newLists)
              }
              setApplyToAllUsers(true)
            } else {
              const firstList = getFirstConfiguredList()
              if (firstList.length > 0) {
                const firstUserWithList = Object.keys(userDocumentLists).find(
                  email => userDocumentLists[email]?.length > 0
                )
                if (firstUserWithList) {
                  setUserDocumentLists({ [firstUserWithList]: firstList })
                }
              }
              setApplyToAllUsers(false)
            }
            setShowApplyToAllConfirm(false)
          }
        }}
        labelCancelConfirmation={t('button.cancel')}
        labelSubmitConfirmation={
          showDeleteConfirm
            ? t('button.delete')
            : t('button.accept')
        }
      />

      {/* Modal de lista de documentos */}
      <DocumentListDialog
        t={t}
        uploadData={uploadData}
        selectedUserForList={selectedUserForList}
        showDocumentListDialog={showDocumentListDialog}
        setShowDocumentListDialog={setShowDocumentListDialog}
        setSelectedUserForList={setSelectedUserForList}
        selectedUsers={selectedUsers}
        secondApprovalUser={secondApprovalUser}
        setSecondApprovalUser={setSecondApprovalUser}
        skip={skip}
        widthColumnOne={widthColumnOne}
        widthColumnFive={widthColumnFive}
        heightGrid={heightGrid}
        documentGroups={documentGroups}
        documentTemplates={documentTemplates}
        userDocumentLists={userDocumentLists}
        onSaveDocumentList={onSaveDocumentList || handleSaveDocumentList}
      />

      {/* Modal de instrucciones */}
      {showInstructionsModal && selectedUserForInstructions && (
        <InteractiveDialog
          title={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.instructions')}
          cancelBtnTitle={t('button.cancel')}
          saveBtnTitle={t('button.save')}
          onClose={() => {
            setShowInstructionsModal(false)
            setInstructionsText('')
            setApplyInstructionsToAll(false)
            setSelectedUserForInstructions(null)
          }}
          onSave={() => {
            if (applyInstructionsToAll) {
              const newInstructions = {}
              selectedUsers.forEach(user => {
                newInstructions[user.email] = instructionsText
              })
              setUserInstructions(newInstructions)
              setGlobalApplyInstructionsToAll(true)
            } else {
              setUserInstructions(prev => ({
                ...prev,
                [selectedUserForInstructions.email]: instructionsText
              }))
              setGlobalApplyInstructionsToAll(false)
            }
            setShowInstructionsModal(false)
            setInstructionsText('')
            setApplyInstructionsToAll(false)
            setSelectedUserForInstructions(null)
          }}
        >
          <TextAreaHLPure
            labelTextArea={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.message.icon')}
            characterLimit={500}
            handleChangeTextArea={(e) => setInstructionsText(e.target.value)}
            rowsTextArea={5}
            valueTextData={instructionsText}
          />
          {selectedUsers.length > 1 && (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <label className="inputHLPure-label">
                  {t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.applyMessageToAll')}
                </label>
                <TooltipHLPure
                  positionTooltip={'top'}
                  titleTooltip={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.applyMessageToAll')}
                  descriptionTooltip={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.applyMessageToAll.tooltip')}
                  informationIcon
                />
              </div>
              <InputSwitchHLPure
                checked={applyInstructionsToAll}
                onChange={(e) => setApplyInstructionsToAll(e.value)}
              />
            </div>
          )}
        </InteractiveDialog>
      )}
      <DialogSystemGLPure
        isWarnign={showWarningModal}
        messageWarning={warningMessage}
        handleWarningClose={() => {
          setShowWarningModal(false)
          setWarningMessage('')
        }}
        handleWarningSubmit={() => {
          setShowWarningModal(false)
          setWarningMessage('')
        }}
        showBtnCancelWarning={true}
        labelWarningBtnCancel={t('button.cancel')}
        titleDialog={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.warning.title')}
      />
    </>
  )
}


export default ThirdPartyDocumentPanel
